// Copyright Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.
/** A machine-readable format for specifying errors in HTTP API responses based on https://tools.ietf.org/html/rfc7807. */
export class ProblemDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            this.operationId = _data["operationId"];
            this.errorSource = _data["errorSource"];
            this.errorCode = _data["errorCode"];
            this.traceId = _data["traceId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        data["operationId"] = this.operationId;
        data["errorSource"] = this.errorSource;
        data["errorCode"] = this.errorCode;
        data["traceId"] = this.traceId;
        return data;
    }
}
